
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/chatgpt",
      function () {
        return require("private-next-pages/android/local/chatgpt/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/chatgpt"])
      });
    }
  